export const Prices = [
  {
    _id: 0,
    name: "$0 - $10",
    array: [0, 10],
  },
  {
    _id: 1,
    name: "$10 - $20",
    array: [10, 20],
  },
  {
    _id: 2,
    name: "$20 - $30",
    array: [20, 30],
  },
  {
    _id: 3,
    name: "$30 - $50",
    array: [30, 50],
  },
  {
    _id: 4,
    name: "$50 - $100",
    array: [50, 100],
  },
];
